import { jsx as _jsx } from "react/jsx-runtime";
/* Text recommending recipes or telling user to select recipes. */
var _RECIPE_TO_LEADIN_TEXT_MAP = {
    chicken: "Chicken Cuisine is a  favorite among our picky eaters, thanks to its\n  high palatability.",
    pork: "Pork Potluck provides an excellent alternative to proteins such as\n  chicken or beef.",
    turkey: "Turkey Fare has the highest protein and lowest fat content among our\n  recipes, making it a great option for supporting a healthy weight.",
    turkey_chicken: "Turkey & Chicken Cookout is rich in essential fatty acids to\n  support the maintenance of a healthy coat.",
};
// Use specific lead in text for meal selection based on recommended recipes
var getRecommendedRecipesDescription = function (recommendedRecipes) {
    var recommendedRecipesDescriptions = [];
    if (recommendedRecipes.includes('pork') && recommendedRecipes.includes('lamb')) {
        return "Pork and lamb can be great alternatives for dogs who\n      can\u2019t eat proteins such as chicken or beef, and help support healthy digestion.";
    }
    for (var _i = 0, recommendedRecipes_1 = recommendedRecipes; _i < recommendedRecipes_1.length; _i++) {
        var recipe = recommendedRecipes_1[_i];
        recommendedRecipesDescriptions.push(_RECIPE_TO_LEADIN_TEXT_MAP[recipe]);
    }
    return recommendedRecipesDescriptions.join(' ');
};
var SelectRecipesText = function (_a) {
    var recommendedRecipes = _a.recommendedRecipes;
    if (recommendedRecipes.length) {
        return _jsx("p", { children: getRecommendedRecipesDescription(recommendedRecipes) });
    }
    return _jsx("p", { children: "Choose recipes to receive in your first box." });
};
export default SelectRecipesText;
